import React from 'react';

const ViewContext = React.createContext({
  tree: true,
});

export default ViewContext;
